import { render, staticRenderFns } from "./PrimeUploader.vue?vue&type=template&id=500693d2&scoped=true&"
import script from "./PrimeUploader.vue?vue&type=script&lang=js&"
export * from "./PrimeUploader.vue?vue&type=script&lang=js&"
import style0 from "./PrimeUploader.vue?vue&type=style&index=0&id=500693d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500693d2",
  null
  
)

export default component.exports